"use client";

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useAtom } from 'jotai';

// lib files
import { passportActivationAtom } from "@/lib/atoms/passport-activation";
import { useHasMounted } from '@/lib/hooks';

// components
import FlowHeader from '@/components/FlowHeader/FlowHeader';

const PassportActivationHeader = () => {
  const [ passportActivateState, _ ] = useAtom(passportActivationAtom);
  const hasMounted = useHasMounted();

  // If the component has not mounted yet, return null to avoid hydration issues
  if (!hasMounted) {
    return null;
  }

  return (
    <FlowHeader
      stationLogo={passportActivateState?.membershipStationLogo || undefined}
      stationShortCommonName={passportActivateState?.membershipStationShortCommonName || undefined}
      showPassportLockup={true}
    />
  );
};

export default PassportActivationHeader;
